import { create } from "zustand";
import { createJSONStorage, persist } from "zustand/middleware";

import type { VesselId } from "../types/vessel";

interface OfficeVesselScopeState {
  selectedVesselId: VesselId | null;
  setSelectedVesselId: (vesselId: VesselId | null) => void;
  clearSelectedVesselId: () => void;
}

interface PersistedOfficeVesselScopeState {
  selectedVesselId: VesselId | null;
}

export const useOfficeVesselScopeStore = create<OfficeVesselScopeState>()(
  persist(
    (set) => ({
      selectedVesselId: null,
      setSelectedVesselId: (selectedVesselId) => set({ selectedVesselId }),
      clearSelectedVesselId: () => set({ selectedVesselId: null }),
    }),
    {
      name: "office-vessel-scope-storage",
      version: 1,
      storage: createJSONStorage(() => window.localStorage),
      partialize: (state) => ({
        selectedVesselId: state.selectedVesselId,
      }),
      migrate: (persistedState: unknown, version) => {
        const typedState = (persistedState ?? {}) as PersistedOfficeVesselScopeState;
        if (version < 1) {
          return { selectedVesselId: null };
        }
        return { selectedVesselId: typedState.selectedVesselId ?? null };
      },
    },
  ),
);
